(function () {
  'use strict';

  const APP_SELECTOR = '[data-multi-size-snapart]';

  let quantities = {};
  let bulkOrderOpen = false;

  let initializationTimer = null;
  let initializationAttempts = 0;

  const MAX_INITIALIZATION_ATTEMPTS = 40;
  const INITIALIZATION_DELAY = 300;

  function getProductInfo() {
    return document.querySelector(
      'product-info[data-product-id]'
    );
  }

  function getVariantData() {
    const productInfo = getProductInfo();

    if (!productInfo) return null;

    const data = productInfo.querySelector(
      '[data-multi-size-variants]'
    );

    if (!data) return null;

    try {
      return JSON.parse(data.textContent);
    } catch (error) {
      console.error(
        '[Multi Size] Variant data error:',
        error
      );

      return null;
    }
  }

  function getOptionGroups() {
    const picker = document.querySelector(
      'variant-selects'
    );

    if (!picker) return [];

    return Array.from(
      picker.querySelectorAll('fieldset')
    ).map((fieldset) => {
      const legend =
        fieldset.querySelector('legend');

      return {
        name: legend
          ? legend.textContent.trim()
          : '',

        inputs: Array.from(
          fieldset.querySelectorAll(
            'input[type="radio"]'
          )
        )
      };
    });
  }

  function getCurrentOptions() {
    return getOptionGroups().map((group) => {
      const checked = group.inputs.find(
        (input) => input.checked
      );

      return checked
        ? checked.value
        : null;
    });
  }

  function findSizeGroup() {
    return getOptionGroups().find((group) => {
      const name = group.name
        .toLowerCase()
        .trim();

      return (
        name === 'size' ||
        name.includes('size')
      );
    });
  }

  function findVariant(options, variants) {
    if (!options || !variants) {
      return null;
    }

    return (
      variants.find((variant) => {
        if (!variant.options) {
          return false;
        }

        return variant.options.every(
          (value, index) =>
            String(value) ===
            String(options[index])
        );
      }) || null
    );
  }

  function getSizeVariants(variants) {
    const groups =
      getOptionGroups();

    const sizeGroup =
      findSizeGroup();

    if (!sizeGroup) {
      return [];
    }

    const sizeIndex =
      groups.findIndex(
        (group) =>
          group.name
            .toLowerCase()
            .trim() ===
          sizeGroup.name
            .toLowerCase()
            .trim()
      );

    if (sizeIndex === -1) {
      return [];
    }

    const currentOptions =
      getCurrentOptions();

    return sizeGroup.inputs.map(
      (input) => {
        const size =
          input.value;

        const options = [
          ...currentOptions
        ];

        options[sizeIndex] =
          size;

        return {
          size,
          variant:
            findVariant(
              options,
              variants
            )
        };
      }
    );
  }

  function areAllSizeVariantsReady() {
    const variants =
      getVariantData();

    if (
      !variants ||
      !variants.length
    ) {
      return false;
    }

    const sizeGroup =
      findSizeGroup();

    if (
      !sizeGroup ||
      !sizeGroup.inputs.length
    ) {
      return false;
    }

    const sizeVariants =
      getSizeVariants(
        variants
      );

    if (
      sizeVariants.length !==
      sizeGroup.inputs.length
    ) {
      return false;
    }

    const missing =
      sizeVariants.filter(
        ({ variant }) =>
          !variant
      );

    if (missing.length) {
      console.log(
        '[Multi Size] Waiting for size variants:',
        missing.map(
          ({ size }) => size
        )
      );

      return false;
    }

    return true;
  }

  function createUI() {
    if (
      document.querySelector(
        APP_SELECTOR
      )
    ) {
      return true;
    }

    const variants =
      getVariantData();

    if (!variants) {
      return false;
    }

    const sizeVariants =
      getSizeVariants(
        variants
      );

    if (!sizeVariants.length) {
      return false;
    }

    const sizeGroup =
      findSizeGroup();

    if (
      !sizeGroup ||
      !sizeGroup.inputs.length
    ) {
      return false;
    }

    const fieldset =
      sizeGroup.inputs[0].closest(
        'fieldset'
      );

    if (!fieldset) {
      return false;
    }

    /*
     * Hide original Shopify Size selector.
     */
    fieldset.classList.add(
      'multi-size-native-hidden'
    );

    const wrapper =
      document.createElement(
        'div'
      );

    wrapper.setAttribute(
      'data-multi-size-snapart',
      ''
    );
   /*
 * MULTI SIZE GRID
 *
 * Desktop:
 * 4 sizes per row.
 *
 * Mobile:
 * 2 sizes per row.
 *
 * Every size row uses the exact same internal layout,
 * so name / minus / quantity / plus stay aligned.
 */
if (!document.querySelector('#multi-size-grid-styles')) {
  const style = document.createElement('style');

  style.id = 'multi-size-grid-styles';

  style.textContent = `
    [data-multi-size-snapart] {
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
    }

   [data-multi-size-snapart] .multi-size-list {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px 10px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  transform: translateX(-100px);
}

    [data-multi-size-snapart] .multi-size-row {
      display: grid;

      /*
       * NAME | MINUS | NUMBER | PLUS
       */
      grid-template-columns:
        minmax(0, 1fr)
        32px
        46px
        32px;

      align-items: center;
      justify-content: stretch;

      width: 100%;
      min-width: 0;
      height: 36px;
      margin: 0;
      padding: 0;

      column-gap: 4px;

      box-sizing: border-box;
    }

    [data-multi-size-snapart] .multi-size-name {
      display: flex;
      align-items: center;
      justify-content: center;

      width: 100%;
      min-width: 0;
      height: 36px;

      margin: 0;
      padding: 0;

      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      text-align: center;
      font-weight: 600;
      line-height: 1;

      box-sizing: border-box;
    }

    [data-multi-size-snapart] .multi-size-minus,
    [data-multi-size-snapart] .multi-size-plus {
      display: flex;
      align-items: center;
      justify-content: center;

      width: 32px;
      min-width: 32px;
      max-width: 32px;

      height: 36px;
      min-height: 36px;
      max-height: 36px;

      margin: 0;
      padding: 0;

      box-sizing: border-box;

      line-height: 1;
    }

    [data-multi-size-snapart] .multi-size-quantity {
      display: block;

      width: 46px;
      min-width: 46px;
      max-width: 46px;

      height: 36px;
      min-height: 36px;
      max-height: 36px;

      margin: 0;
      padding: 0 3px;

      text-align: center;
      line-height: 1;

      box-sizing: border-box;
    }

    [data-multi-size-snapart] .multi-size-total {
      width: 100%;
      margin-top: 14px;
      box-sizing: border-box;
    }

    /*
     * MOBILE
     */
    [data-multi-size-snapart] .multi-size-minus,
[data-multi-size-snapart] .multi-size-quantity,
[data-multi-size-snapart] .multi-size-plus {
  transform: translateX(-18px);
}
    @media screen and (max-width: 749px) {

      [data-multi-size-snapart] .multi-size-list {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 10px 8px;
      }

      [data-multi-size-snapart] .multi-size-row {
        grid-template-columns:
          minmax(0, 1fr)
          30px
          42px
          30px;

        column-gap: 4px;

        height: 34px;
      }

      [data-multi-size-snapart] .multi-size-name {
        height: 34px;
        font-size: 14px;
      }

      [data-multi-size-snapart] .multi-size-minus,
      [data-multi-size-snapart] .multi-size-plus {
        width: 30px;
        min-width: 30px;
        max-width: 30px;

        height: 34px;
        min-height: 34px;
        max-height: 34px;
      }

      [data-multi-size-snapart] .multi-size-quantity {
        width: 42px;
        min-width: 42px;
        max-width: 42px;

        height: 34px;
        min-height: 34px;
        max-height: 34px;
      }
    }
  `;

  document.head.appendChild(style);
}
    wrapper.innerHTML = `
      <button
        type="button"
        class="multi-size-toggle"
        style="
          width: 65% !important;
          position: relative !important;
          left: 50% !important;
          transform: translateX(-50%) !important;
          height: 45px !important;
          min-height: 45px !important;
        "
        aria-expanded="${bulkOrderOpen ? 'true' : 'false'}"
        aria-controls="multi-size-content"
      >
        <span
          class="multi-size-title"
          style="
            display: block;
            width: 100%;
            text-align: center;
            font-size: 20px !important;
            font-weight: 700;
          "
        >
          Bulk Order
        </span>

        <span
          class="multi-size-arrow"
          aria-hidden="true"
        >
          ${bulkOrderOpen ? '⌃' : '⌄'}
        </span>
      </button>

      <div
        class="multi-size-content"
        id="multi-size-content"
        ${bulkOrderOpen ? '' : 'hidden'}
      >
        <div class="multi-size-list"></div>

        <div class="multi-size-total">
  Total: <strong>0</strong>

  <div class="multi-size-limit">
    *max 100 units per size
  </div>
</div>
    `;

    const list =
      wrapper.querySelector(
        '.multi-size-list'
      );

    sizeVariants.forEach(
      ({ size, variant }) => {
        if (!variant) {
          return;
        }

        const row =
          document.createElement(
            'div'
          );

        row.className =
          'multi-size-row';

        row.dataset.variantId =
          variant.id;

        row.dataset.size =
          size;

        const savedQuantity =
          Number(
            quantities[size]
          ) || 0;

        row.innerHTML = `
          <div class="multi-size-name">
            ${escapeHtml(size)}
          </div>

          <button
            type="button"
            class="multi-size-minus"
            aria-label="Decrease ${escapeHtml(size)}"
          >
            −
          </button>

          <input
            type="number"
            class="multi-size-quantity"
            data-size="${escapeHtml(size)}"
            value="${savedQuantity}"
            min="0"
            step="1"
            inputmode="numeric"
            aria-label="${escapeHtml(size)} quantity"
          >

          <button
            type="button"
            class="multi-size-plus"
            aria-label="Increase ${escapeHtml(size)}"
          >
            +
          </button>
        `;

        list.appendChild(row);
      }
    );

    const expectedCount =
      sizeGroup.inputs.length;

    const createdCount =
      list.querySelectorAll(
        '.multi-size-row'
      ).length;

    if (
      createdCount !==
      expectedCount
    ) {
      console.log(
        '[Multi Size] UI not ready yet.',
        {
          expectedCount,
          createdCount
        }
      );

      fieldset.classList.remove(
        'multi-size-native-hidden'
      );

      return false;
    }

    fieldset.insertAdjacentElement(
      'afterend',
      wrapper
    );

    const toggle =
      wrapper.querySelector(
        '.multi-size-toggle'
      );

    const content =
      wrapper.querySelector(
        '.multi-size-content'
      );

    const arrow =
      wrapper.querySelector(
        '.multi-size-arrow'
      );

    if (
      toggle &&
      content &&
      arrow
    ) {
      toggle.addEventListener(
        'click',
        function () {
          const isOpen =
            toggle.getAttribute(
              'aria-expanded'
            ) === 'true';

          const newState =
            !isOpen;

          bulkOrderOpen =
            newState;

          toggle.setAttribute(
            'aria-expanded',
            String(newState)
          );

          content.hidden =
            !newState;

          arrow.textContent =
            newState
              ? '⌃'
              : '⌄';
        }
      );
    }

    updateTotal(wrapper);

    attachEvents(wrapper);

    console.log(
      '[Multi Size] UI created successfully.'
    );

    console.log(
      '[Multi Size] Variants:',
      sizeVariants.map(
        ({ size, variant }) => ({
          size,
          variantId:
            variant?.id
        })
      )
    );

    console.log(
      '[Multi Size] Quantities:',
      quantities
    );

    return true;
  }

  function attachEvents(wrapper) {

    /*
     * PLUS / MINUS
     *
     * We DO NOT change the native Shopify Size here.
     */
    wrapper.addEventListener(
      'click',
      function (event) {
        const button =
          event.target.closest(
            '.multi-size-minus, .multi-size-plus'
          );

        if (!button) {
          return;
        }

        const row =
          button.closest(
            '.multi-size-row'
          );

        if (!row) {
          return;
        }

        const size =
          row.dataset.size;

        let quantity =
          Number(
            quantities[size]
          ) || 0;

        if (
          button.classList.contains(
            'multi-size-plus'
          )
        ) {
          quantity++;
        }

        if (
          button.classList.contains(
            'multi-size-minus'
          )
        ) {
          quantity =
            Math.max(
              0,
              quantity - 1
            );
        }

        quantities[size] =
          quantity;

        const quantityElement =
          row.querySelector(
            '.multi-size-quantity'
          );

        if (quantityElement) {
          quantityElement.value =
            quantity;
        }

        updateTotal(wrapper);

        console.log(
          `[Multi Size] ${size} = ${quantity}`
        );

        console.log(
          '[Multi Size] Selected quantities:',
          JSON.stringify(
            quantities
          )
        );
      }
    );

    /*
     * MANUAL QUANTITY INPUT
     *
     * IMPORTANT:
     * Stop the input event here so it cannot bubble
     * into Shopify/SnapArt handlers that may cause
     * product-info to re-render.
     *
     * We still allow the input itself to behave normally.
     */
    wrapper.addEventListener(
      'input',
      function (event) {
        const input =
          event.target.closest(
            '.multi-size-quantity'
          );

        if (!input) {
          return;
        }

        /*
         * IMPORTANT FIX #2:
         * Prevent Shopify/SnapArt document-level
         * bubble listeners from seeing this event.
         */
        event.stopPropagation();

        const row =
          input.closest(
            '.multi-size-row'
          );

        if (!row) {
          return;
        }

        const size =
          row.dataset.size;

        /*
         * Allow empty field while typing.
         */
        if (
          input.value === ''
        ) {
          quantities[size] =
            0;

          updateTotal(wrapper);

          return;
        }

        let quantity =
          parseInt(
            input.value,
            10
          );

        if (
          isNaN(quantity) ||
          quantity < 0
        ) {
          quantity = 0;
        }

        quantities[size] =
          quantity;

        /*
         * No selectNativeSize().
         * No Shopify change event.
         */
        updateTotal(wrapper);

        console.log(
          `[Multi Size] ${size} = ${quantity}`
        );

        console.log(
          '[Multi Size] Selected quantities:',
          JSON.stringify(
            quantities
          )
        );
      }
    );

    /*
     * CHANGE / BLUR-LIKE NORMALIZATION
     *
     * Also stop the event from reaching
     * Shopify/SnapArt listeners.
     */
    wrapper.addEventListener(
      'change',
      function (event) {
        const input =
          event.target.closest(
            '.multi-size-quantity'
          );

        if (!input) {
          return;
        }

        /*
         * IMPORTANT FIX #2:
         * Prevent Shopify/SnapArt from reacting to
         * the quantity input's change event.
         */
        event.stopPropagation();

        const row =
          input.closest(
            '.multi-size-row'
          );

        if (!row) {
          return;
        }

        const size =
          row.dataset.size;

        let quantity =
          parseInt(
            input.value,
            10
          );

        if (
          isNaN(quantity) ||
          quantity < 0
        ) {
          quantity = 0;
        }

        quantities[size] =
          quantity;

        input.value =
          quantity;

        updateTotal(wrapper);

        /*
         * IMPORTANT:
         * Absolutely NO native Size change here.
         */
      }
    );
  }

  /*
   * Returns the first Bulk Order size
   * that has quantity > 0.
   *
   * This will become the SnapArt base variant.
   */
  function getFirstSelectedBulkSize() {
    const wrapper =
      document.querySelector(
        APP_SELECTOR
      );

    if (!wrapper) {
      return null;
    }

    const rows =
      wrapper.querySelectorAll(
        '.multi-size-row'
      );

    for (
      const row of rows
    ) {
      const input =
        row.querySelector(
          '.multi-size-quantity'
        );

      const quantity =
        Number(
          input?.value
        ) || 0;

      const variantId =
        Number(
          row.dataset.variantId
        );

      if (
        quantity > 0 &&
        variantId
      ) {
        return {
          size:
            row.dataset.size,
          variantId,
          quantity
        };
      }
    }

    return null;
  }

  /*
   * Prepare Shopify/SnapArt for the correct
   * Bulk Order base variant WITHOUT dispatching
   * a "change" event.
   *
   * This preserves the existing Color fix.
   */
  function prepareNativeVariantForSnapart(
    button
  ) {
    const selected =
      getFirstSelectedBulkSize();

    if (
      !selected ||
      !selected.variantId
    ) {
      return false;
    }

    console.log(
      '[Multi Size] Preparing SnapArt base variant:',
      selected
    );

    /*
     * 1. Directly check native Size radio.
     *
     * NO change event.
     */
    const sizeGroup =
      findSizeGroup();

    if (sizeGroup) {
      const nativeInput =
        sizeGroup.inputs.find(
          (input) =>
            String(input.value) ===
            String(selected.size)
        );

      if (nativeInput) {
        nativeInput.checked =
          true;
      }
    }

    /*
     * 2. Update Shopify product form
     * hidden variant ID.
     */
    let form =
      button?.closest('form');

    if (!form) {
      const productInfo =
        getProductInfo();

      if (productInfo) {
        form =
          productInfo.querySelector(
            'form[action*="/cart/add"]'
          );
      }
    }

    if (!form) {
      form =
        document.querySelector(
          'form[action*="/cart/add"]'
        );
    }

    const idInput =
      form?.querySelector(
        'input[name="id"]'
      );

    if (idInput) {
      idInput.value =
        String(
          selected.variantId
        );

      console.log(
        '[Multi Size] Shopify form variant ID prepared:',
        idInput.value
      );
    } else {
      console.warn(
        '[Multi Size] Shopify variant ID input not found.'
      );
    }

    return true;
  }

  function updateTotal(wrapper) {
    let total = 0;

    Object.values(
      quantities
    ).forEach((quantity) => {
      total +=
        Number(quantity) || 0;
    });

    const totalElement =
      wrapper.querySelector(
        '.multi-size-total strong'
      );

    if (totalElement) {
      totalElement.textContent =
        total;
    }
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function init() {
    const productInfo =
      getProductInfo();

    if (!productInfo) {
      return false;
    }

    if (
      document.querySelector(
        APP_SELECTOR
      )
    ) {
      return true;
    }

    if (
      !areAllSizeVariantsReady()
    ) {
      return false;
    }

    return createUI();
  }

  function scheduleInitialization() {
    if (
      initializationTimer
    ) {
      return;
    }

    initializationTimer =
      setTimeout(() => {
        initializationTimer =
          null;

        if (
          document.querySelector(
            APP_SELECTOR
          )
        ) {
          initializationAttempts =
            0;

          return;
        }

        initializationAttempts++;

        const success =
          init();

        if (success) {
          initializationAttempts =
            0;

          console.log(
            '[Multi Size] Initialization complete.'
          );

          return;
        }

        if (
          initializationAttempts <
          MAX_INITIALIZATION_ATTEMPTS
        ) {
          scheduleInitialization();
        } else {
          console.warn(
            '[Multi Size] Initialization timed out.'
          );

          initializationAttempts =
            0;
        }
      }, INITIALIZATION_DELAY);
  }

  /*
   * Shopify replaces parts of product-info
   * when a real variant option changes.
   *
   * Bulk Order will be recreated automatically.
   *
   * quantities and open/closed state stay in memory.
   */
  const observer =
    new MutationObserver(
      () => {
        const productInfo =
          getProductInfo();

        if (!productInfo) {
          return;
        }

        if (
          !document.querySelector(
            APP_SELECTOR
          )
        ) {
          scheduleInitialization();
        }
      }
    );

  let snapartCartProcessing =
    false;

  let snapartCartBefore =
    null;

  async function getCart() {
    const response =
      await fetch(
        '/cart.js?_multi_size_cart=' +
          Date.now(),
        {
          credentials:
            'same-origin',
          cache: 'no-store'
        }
      );

    if (!response.ok) {
      throw new Error(
        'Could not load Shopify cart.'
      );
    }

    return await response.json();
  }

  function getSelectedSizeQuantities() {
    const wrapper =
      document.querySelector(
        APP_SELECTOR
      );

    if (!wrapper) {
      return {};
    }

    const result = {};

    wrapper
      .querySelectorAll(
        '.multi-size-row'
      )
      .forEach((row) => {
        const size =
          row.dataset.size;

        const input =
          row.querySelector(
            '.multi-size-quantity'
          );

        const quantity =
          Number(
            input?.value
          ) || 0;

        const variantId =
          Number(
            row.dataset.variantId
          );

        if (
          quantity > 0 &&
          variantId
        ) {
          result[size] = {
            quantity,
            variantId
          };
        }
      });

    return result;
  }

  function findNewSnapartItem(
    beforeCart,
    afterCart
  ) {
    const beforeMetadata =
      new Set();

    if (
      beforeCart &&
      Array.isArray(
        beforeCart.items
      )
    ) {
      beforeCart.items.forEach(
        (item) => {
          const metadataId =
            item.properties?.[
              '_$snapart$_'
            ]?.cartItemMetadataId;

          if (metadataId) {
            beforeMetadata.add(
              metadataId
            );
          }
        }
      );
    }

    return afterCart.items.find(
      (item) => {
        const metadataId =
          item.properties?.[
            '_$snapart$_'
          ]?.cartItemMetadataId;

        return (
          metadataId &&
          !beforeMetadata.has(
            metadataId
          )
        );
      }
    );
  }

  async function addSnapartVariant(
    variantId,
    quantity,
    properties
  ) {
    const response =
      await fetch(
        '/cart/add.js',
        {
          method: 'POST',
          credentials:
            'same-origin',
          headers: {
            'Content-Type':
              'application/json',
            Accept:
              'application/json'
          },
          body:
            JSON.stringify({
              items: [
                {
                  id: variantId,
                  quantity,
                  properties
                }
              ]
            })
        }
      );

    if (!response.ok) {
      const text =
        await response.text();

      throw new Error(
        `Could not add variant ${variantId}: ${text}`
      );
    }

    return await response.json();
  }

  async function updateSnapartVariantQuantity(
    lineKey,
    quantity
  ) {
    const response =
      await fetch(
        '/cart/change.js',
        {
          method: 'POST',
          credentials:
            'same-origin',
          headers: {
            'Content-Type':
              'application/json',
            Accept:
              'application/json'
          },
          body:
            JSON.stringify({
              id: lineKey,
              quantity
            })
        }
      );

    if (!response.ok) {
      const text =
        await response.text();

      throw new Error(
        `Could not update SnapArt line ${lineKey}: ${text}`
      );
    }

    return await response.json();
  }

  async function refreshCartDrawer(
    expectedLineCount = null
  ) {
    try {
      console.log(
        '[Multi Size] Starting cart drawer synchronization...'
      );

      const cartDrawer =
        document.querySelector(
          'cart-drawer'
        );

      if (!cartDrawer) {
        console.warn(
          '[Multi Size] cart-drawer not found.'
        );

        return false;
      }

      if (
        typeof cartDrawer.renderContents !==
        'function'
      ) {
        console.warn(
          '[Multi Size] cartDrawer.renderContents() not found.'
        );

        return false;
      }

      const root =
        window.Shopify?.routes?.root ||
        '/';

      for (
        let attempt = 1;
        attempt <= 10;
        attempt++
      ) {
        console.log(
          `[Multi Size] Drawer sync attempt ${attempt}/10`
        );

        const cartResponse =
          await fetch(
            '/cart.js?_multi_size_sync=' +
              Date.now(),
            {
              credentials:
                'same-origin',
              cache: 'no-store'
            }
          );

        if (!cartResponse.ok) {
          throw new Error(
            'Could not load cart during drawer synchronization.'
          );
        }

        const cart =
          await cartResponse.json();

        const targetLineCount =
          expectedLineCount ??
          cart.items.length;

        console.log(
          '[Multi Size] Shopify cart:',
          cart.items.length,
          'lines.'
        );

        console.log(
          '[Multi Size] Expected drawer lines:',
          targetLineCount
        );

        const separator =
          root.includes('?')
            ? '&'
            : '?';

        const sectionsUrl =
          `${root}${separator}sections=cart-drawer,cart-icon-bubble&_multi_size_refresh=${Date.now()}`;

        const sectionsResponse =
          await fetch(
            sectionsUrl,
            {
              method: 'GET',
              credentials:
                'same-origin',
              headers: {
                Accept:
                  'application/json'
              },
              cache: 'no-store'
            }
          );

        if (
          !sectionsResponse.ok
        ) {
          throw new Error(
            `Cart drawer refresh failed: ${sectionsResponse.status}`
          );
        }

        const sections =
          await sectionsResponse.json();

        if (
          !sections[
            'cart-drawer'
          ]
        ) {
          console.warn(
            '[Multi Size] cart-drawer section missing from response.'
          );

          await new Promise(
            (resolve) =>
              setTimeout(
                resolve,
                500
              )
          );

          continue;
        }

        cartDrawer.renderContents({
          id: Date.now(),
          sections
        });

        await new Promise(
          (resolve) =>
            setTimeout(
              resolve,
              400
            )
        );

        const visibleLines =
          cartDrawer.querySelectorAll(
            '.cart-item'
          ).length;

        console.log(
          '[Multi Size] Drawer currently contains:',
          visibleLines,
          'lines.'
        );

        if (
          visibleLines >=
          targetLineCount
        ) {
          console.log(
            '[Multi Size] Cart drawer synchronized successfully.'
          );

          return true;
        }

        console.log(
          '[Multi Size] Drawer is still missing lines. Retrying...'
        );

        await new Promise(
          (resolve) =>
            setTimeout(
              resolve,
              600
            )
        );
      }

      console.warn(
        '[Multi Size] Drawer synchronization timed out.'
      );

      return false;

    } catch (error) {
      console.error(
        '[Multi Size] Cart drawer synchronization error:',
        error
      );

      return false;
    }
  }

  async function processSnapartCart() {
    if (
      snapartCartProcessing
    ) {
      return;
    }

    const selectedQuantities =
      getSelectedSizeQuantities();

    const totalQuantity =
      Object.values(
        selectedQuantities
      ).reduce(
        (total, item) =>
          total +
          item.quantity,
        0
      );

    if (
      totalQuantity <= 0
    ) {
      console.log(
        '[Multi Size] No quantities selected.'
      );

      return;
    }

    snapartCartProcessing =
      true;

    try {
      console.log(
        '[Multi Size] Waiting for SnapArt cart update...'
      );

      let snapartItem =
        null;

      for (
        let attempt = 0;
        attempt < 15;
        attempt++
      ) {
        await new Promise(
          (resolve) =>
            setTimeout(
              resolve,
              400
            )
        );

        const afterCart =
          await getCart();

        snapartItem =
          findNewSnapartItem(
            snapartCartBefore,
            afterCart
          );

        if (
          snapartItem
        ) {
          break;
        }
      }

      if (!snapartItem) {
        console.warn(
          '[Multi Size] Could not identify new SnapArt cart item.'
        );

        return;
      }

      console.log(
        '[Multi Size] SnapArt item found:',
        snapartItem
      );

      const properties =
        snapartItem.properties ||
        {};

      console.log(
        '[Multi Size] All SnapArt properties copied:',
        properties
      );

      const baseVariantId =
        Number(
          snapartItem.variant_id
        );

      console.log(
        '[Multi Size] SnapArt base variant:',
        baseVariantId
      );

      const baseEntry =
        Object.entries(
          selectedQuantities
        ).find(
          ([, data]) =>
            Number(
              data.variantId
            ) ===
            baseVariantId
        );

      if (
        baseEntry
      ) {
        const [
          baseSize,
          baseData
        ] = baseEntry;

        const wantedQuantity =
          Number(
            baseData.quantity
          );

        console.log(
          `[Multi Size] Base ${baseSize}: requested ×${wantedQuantity}, SnapArt added ×${snapartItem.quantity}`
        );

        if (
          Number(
            snapartItem.quantity
          ) !==
          wantedQuantity
        ) {
          console.log(
            `[Multi Size] Updating base ${baseSize} to ×${wantedQuantity}`
          );

          await updateSnapartVariantQuantity(
            snapartItem.key,
            wantedQuantity
          );
        }
      } else {

        /*
         * IMPORTANT FIX #1:
         *
         * SnapArt initially adds the currently selected
         * native Shopify Size.
         *
         * If that Size is NOT selected in Bulk Order,
         * the SnapArt line must be removed.
         *
         * Previously this only logged a warning, leaving
         * the unwanted native Size in the cart.
         */
        console.log(
          '[Multi Size] Removing SnapArt base variant because it is not selected in Bulk Order:',
          baseVariantId
        );

        await updateSnapartVariantQuantity(
          snapartItem.key,
          0
        );
      }

      for (
        const [
          size,
          data
        ] of Object.entries(
          selectedQuantities
        )
      ) {
        const variantId =
          Number(
            data.variantId
          );

        if (
          variantId ===
          baseVariantId
        ) {
          console.log(
            `[Multi Size] ${size}: base variant already handled.`
          );

          continue;
        }

        console.log(
          `[Multi Size] Adding ${size} × ${data.quantity}`,
          'Variant:',
          variantId
        );

        await addSnapartVariant(
          variantId,
          data.quantity,
          properties
        );
      }

      const finalCart =
        await getCart();

      console.log(
        '=== MULTI SIZE SNAPART COMPLETE ==='
      );

      console.log(
        '[Multi Size] Final item count:',
        finalCart.item_count
      );

      console.log(
        '[Multi Size] Final cart lines:',
        finalCart.items.length
      );

      console.log(
        '[Multi Size] Final cart:',
        finalCart.items
      );

      await refreshCartDrawer(
        finalCart.items.length
      );

      console.log(
        '[Multi Size] Cart drawer synchronization completed.'
      );

    } catch (error) {
      console.error(
        '[Multi Size] SnapArt cart processing error:',
        error
      );
    } finally {
      snapartCartProcessing =
        false;

      snapartCartBefore =
        null;
    }
  }

  function watchSnapartAddToCart() {
    document.addEventListener(
      'click',
      async function (event) {
        const button =
          event.target.closest(
            '.bnz-snapart-button'
          );

        if (!button) {
          return;
        }

        const text =
          button.textContent
            .trim()
            .toLowerCase();

        if (
          text !==
          'add to cart'
        ) {
          return;
        }

        console.log(
          '[Multi Size] SnapArt Add to cart clicked.'
        );

        /*
         * IMPORTANT:
         *
         * Prepare the FIRST selected Bulk Order
         * size BEFORE waiting for cart.js.
         *
         * This runs synchronously in capture phase,
         * before SnapArt's own click handler.
         *
         * NO Shopify change event is fired.
         */
        const prepared =
          prepareNativeVariantForSnapart(
            button
          );

        console.log(
          '[Multi Size] SnapArt variant prepared:',
          prepared
        );

        try {
          /*
           * Capture cart BEFORE SnapArt modifies it.
           */
          snapartCartBefore =
            await getCart();

          console.log(
            '[Multi Size] Cart before SnapArt:',
            snapartCartBefore
          );

          setTimeout(
            () => {
              processSnapartCart();
            },
            100
          );

        } catch (error) {
          console.error(
            '[Multi Size] Could not capture cart before SnapArt:',
            error
          );
        }
      },
      true
    );
  }

  function start() {
    scheduleInitialization();

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  watchSnapartAddToCart();

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }

})();